import React, { lazy, Suspense, useState, useEffect } from "react";
import FetchContent from "../dynamic/fetchContent.jsx";
import axios from "../../api/axios.js";
import useAuth from "../../hooks/useAuth.js";
import {
  contactDefaultDisplay,
  contactDefaultEntries,
  accommodationFormDefaultDisplay,
  accFormDefaultEntries,
} from "../../languages/defaultEntries.js";
import FetchCarouselContent from "../dynamic/fetchCarouselContent.jsx";
import Equipment from "./Equipment.jsx";
import Reviewsjson from "./Reviewsjson.jsx";
import ReviewsjsonEdit from "./ReviewsjsonEdit.jsx";
import Content from "../dynamic/Content.jsx";
import ImageContent from "../dynamic/ImageContent.jsx";
import CarouselContent from "./CarouselContent.js";
import Map from "../dynamic/Map";
import ReviewLinks from "./ReviewLinks.jsx";
import { useTranslation } from "react-i18next";
import { Certificates } from "./Certificates.jsx";
import { Link } from "react-router-dom";

const WEBSITE_URL = "/dashboard/key";
const FetchImage = lazy(() => import("../dynamic/fetchImage.jsx"));
const WEBSITE_URL_CONTACT = "/contact";
const WEBSITE_CAL = "/websiteAuth/calendar";

export default function Home() {
  const { username } = useAuth();

  const [accomodationType, setAccomodationType] = useState("");
  const [guests, setGuests] = useState(1);
  const [city, setCity] = useState("");
  const [nameAccommodation, setNameAccommodation] = useState("");
  const [meterSquared, setMeterSquared] = useState(0); // default value [m²]
  const [containsDefault, setContainsDefault] = useState(true);
  const [loadComplete, setLoadComplete] = useState(true);
  const [calendar, setCalendar] = useState([]);
  const [homePageVideoURL, setHomePageVideoURL] = useState("");

  const { auth } = useAuth();
  const { t } = useTranslation();

  const accDefaultDisplay = accommodationFormDefaultDisplay;
  const [propertyType, setPropertyType] = useState("");

  useEffect(() => {
    if (
      accomodationType !== accFormDefaultEntries.type &&
      guests !== accFormDefaultEntries.guests &&
      city !== contactDefaultEntries.city &&
      nameAccommodation !== accFormDefaultEntries.nameAccommodation
    ) {
      setContainsDefault(false);
    }
  }, [accomodationType, guests, city, nameAccommodation]);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        await axios
          .get(WEBSITE_URL, {
            params: {
              username: username,
              key: "accomodationType", // specify the column you want to retrieve
            },
          })
          .then((res) => {
            setAccomodationType(res?.data?.accomodationType);
          });
        await axios
          .get(WEBSITE_URL, {
            params: {
              username: username,
              key: "guests", // specify the column you want to retrieve
            },
          })
          .then((res) => {
            setGuests(res?.data?.guests);
          });
        await axios
          .get(WEBSITE_URL, {
            params: {
              username: username,
              key: "nameAccommodation", // specify the column you want to retrieve
            },
          })
          .then((res) => {
            setNameAccommodation(res?.data?.nameAccommodation);
          });
        await axios
          .get(WEBSITE_URL, {
            params: {
              username: username,
              key: "homePageVideoURL", 
            },
          })
          .then((res) => {
            setHomePageVideoURL(res?.data?.homePageVideoURL);
          });
        await axios
          .get(WEBSITE_URL, {
            params: {
              username: username,
              key: "meterSquared", // specify the column you want to retrieve
            },
          })
          .then((res) => {
            setMeterSquared(res?.data?.meterSquared);
          });

           await axios.get(WEBSITE_CAL, {
                  params: { username },
                }).then((res) => {
                  setCalendar(res?.data?.calendar);
                }).catch((err) => {
                  console.log(err);
                });
        await axios
          .get(WEBSITE_URL_CONTACT, {
            params: {
              username: username,
              art: "nl",
              title: "contact",
            },
          })
          .then((res) => {
            console.log('hgdygsd',res.data.entry);
            setCity(res?.data?.entry?.city);
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchContent();
  }, [username]);

  useEffect(() => {
    setLoadComplete(
      !!accomodationType && !!guests && !!nameAccommodation && !!city
    );
  }, [loadComplete, accomodationType, guests, nameAccommodation, city]);
  // display empty string if db contains default entry
  useEffect(() => {
    setPropertyType(
      accomodationType === accFormDefaultEntries.type || !loadComplete
        ? ""
        : t("codes.acc_types." + accomodationType)
    );
  }, [accomodationType, t, loadComplete]);

  function extractYouTubeId(url) {
  const regExp =
    /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[1].length === 11 ? match[1] : null;
}

const allowedDomains = [
  "hausclarysse.com",
  "activemontgoflat.com",
  "studiogocki.com",
  "thecityghent.com"
];

const currentDomain = window.location.hostname;
const showMoreButton = allowedDomains.includes(currentDomain);

  return (
    <div className="default">
      <div className="image-content home-hero">
        <Suspense fallback={<h1>Still Loading…</h1>}>
          {!auth?.role ? (
            <FetchImage title="home" type="image-home" />
          ) : (
            <ImageContent title="home" username={username} type="image-home" />
          )}
          <div className="hero-conent">
            <h2>
              {nameAccommodation === accFormDefaultEntries.nameAccommodation
                ? accDefaultDisplay.nameAccommodation
                : nameAccommodation}
            </h2>
            {!auth?.role ? (
              <p style={{ textAlign: "justify" }}>
                <FetchContent title="accommodation-about" />
              </p>
            ) : (
              <p>
                <Content title={"accommodation-about"} styling="p" />
              </p>
            )}

            {calendar && calendar !== "no" && (
              <Link className="book-now-btn" to={calendar}>
                Book Now
              </Link>
            )}
            {showMoreButton && (
              <a
                href="https://claryssesignaturestays.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="book-now-btn"
                style={{ marginTop: "1rem" }}
              >
                We have more accommodations →
              </a>
            )}
          </div>
        </Suspense>
      </div>

      {homePageVideoURL && (
        <div className="video-section stripe container">
          <div
            className="video-wrapper"
            style={{
              position: "relative",
              paddingTop: "56.25%",
              marginTop: "2rem",
            }}
          >
            <iframe
              src={`https://www.youtube.com/embed/${extractYouTubeId(
                homePageVideoURL
              )}?autoplay=1&mute=1&loop=1&playlist=${extractYouTubeId(
                homePageVideoURL
              )}&controls=0&rel=0&modestbranding=1`}
              title="Intro Video"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              }}
            ></iframe>
          </div>
        </div>
      )}

      {loadComplete && (
        <div>
          {containsDefault && Boolean(auth?.role) && (
            <p className="hint-msg">{t("hints.contains_default")}</p>
          )}

          <div className="stripe container about-us-main">
            <div className="about-us-main-img">
              {!auth?.role ? (
                <FetchImage
                  title="home-about"
                  type="about-us-main-img-container"
                />
              ) : (
                <ImageContent
                  title="home-about"
                  username={username}
                  type="about-us-main-img-container"
                />
              )}
            </div>

            <div className="about-us-main-content">
              <div className="heading-brannew">
                {" "}
                {nameAccommodation === accFormDefaultEntries.nameAccommodation
                  ? accDefaultDisplay.nameAccommodation
                  : nameAccommodation}{" "}
              </div>

              <div className="subheading-brannew">
                {" "}
                {propertyType} - {t("home_page.upto")}
                {guests === accFormDefaultEntries.guests
                  ? accDefaultDisplay.guests
                  : guests}{" "}
                {t("home_page.guests")} - {t("home_page.in")}{" "}
                {city === contactDefaultEntries.city
                  ? contactDefaultDisplay.city
                  : city}{" "}
                ({meterSquared} m²)
              </div>

              {!auth?.role ? (
                <div className="p-brandnew">
                  <FetchContent title="p-accommodation" />
                </div>
              ) : (
                <div className="p-brandnew">
                  <Content title={"p-accommodation"} styling="p" />
                </div>
              )}
            </div>
          </div>

          {/* <div className="stripe container ws-pre-wrap">
            <div className="p">
              <h1>
                {" "}
                {nameAccommodation === accFormDefaultEntries.nameAccommodation
                  ? accDefaultDisplay.nameAccommodation
                  : nameAccommodation}{" "}
              </h1>
              <h2>
                {" "}
                {propertyType} - {t("home_page.upto")}
                {guests === accFormDefaultEntries.guests
                  ? accDefaultDisplay.guests
                  : guests}{" "}
                {t("home_page.guests")} - {t("home_page.in")}{" "}
                {city === contactDefaultEntries.city
                  ? contactDefaultDisplay.city
                  : city}{" "}
                ({meterSquared} m²)
              </h2>
              <hr></hr>
            </div>
            {!auth?.role ? (
              <div className="p">
                <FetchContent title="p-accommodation" />
              </div>
            ) : (
              <div className="p">
                <Content title={"p-accommodation"} styling="p" />
              </div>
            )}
          </div> */}
          <div className="stripe stripe-carousel">
            <Suspense fallback={<h1>Still Loading…</h1>}>
              {!auth?.role ? (
                <FetchCarouselContent title="home" username={username} />
              ) : (
                <CarouselContent
                  title="home"
                  username={username}
                  maxImages={15}
                />
              )}
            </Suspense>
          </div>

          <div className="stripe">
            <div className="container new-container-padding">
              <h2> {t("home_page.equipment")} </h2>
              <Equipment />
            </div>
          </div>

          {/* <div className="stripe-services">
            <Services />
          </div> */}

          <div>{!auth?.role ? <Map /> : <Map adminUser={true} />}</div>

          <div className=" stripe">
            <div className="container text-center">
              {!auth?.role ? <Reviewsjson /> : <ReviewsjsonEdit />}
            </div>
          </div>
          <div className=" stripe">
            <div className="container text-center">
              <Certificates />
            </div>
          </div>
          <div className="stripe">
            <ReviewLinks />
          </div>
        </div>
      )}
    </div>
  );
}
